<main style="direction: rtl">
    <section class="w-full h-dvh flex flex-col" id="main">
        <nav
            class="animate-fade-down animate-once animate-duration-[1500ms] animate-delay-300 w-full items-center px-5 flex z-10 absolute top-0 h-24 bg-[#31323366]"
        >
            <img
                src="./assets/images/Group 1171275299.svg"
                class="w-[228px] ml-16"
            />
            <a routerLink="/login">الرئيسية</a>
            <a routerLink="/geoPortalBaladya">لوحة التحكم</a>
            <a routerLink="/landing" fragment="plans">تصحيح المخططات</a>
            <a routerLink="/landing" fragment="reports">التقارير الدورية</a>
            <a routerLink="/landing" fragment="sec">نبذة عن المشروع</a>
        </nav>

        <div class="w-full h-full">
            <c-carousel class="size-full">
                <c-carousel-indicators> </c-carousel-indicators>
                <c-carousel-inner class="h-dvh w-full">
                    <c-carousel-item
                        class="size-full"
                        *ngFor="let slide of slides"
                    >
                        <div class="relative size-full">
                            <img
                                alt="{{ slide.title }}"
                                class="h-dvh w-full top-[-200px] object-cover"
                                src="{{ slide.src }}"
                            />
                            <div
                                class="absolute top-0 items-center justify-center flex text-center z-10 size-full slide-bg"
                            >
                                <h3
                                    style="
                                        font-family: Almarai;
                                        font-weight: 800;
                                    "
                                    class="text-white max-w-[700px] text-4xl animate-flip-up animate-once animate-duration-500 animate-delay-[700ms]"
                                >
                                    {{ slide.title }}
                                </h3>
                            </div>
                        </div>
                    </c-carousel-item>
                </c-carousel-inner>
                <c-carousel-control
                    [routerLink]
                    direction="prev"
                    caption="."
                ></c-carousel-control>
                <c-carousel-control
                    [routerLink]
                    direction="next"
                    caption="."
                ></c-carousel-control>
            </c-carousel>
        </div>
    </section>

    <section class="py-5 px-2" id="plans">
        <app-page-title
            class="mx-10"
            title="المخططات في ارقام"
        ></app-page-title>
        <div class="flex mt-5 w-full">
            <!-- <img
                appOnscrollAnimated
                class="cursor-pointer"
                (click)="
                    planedSlider.scrollTo({
                        left: 100,
                        behavior: 'smooth'
                    })
                "
                src="./assets/images/Group 210.svg"
            /> -->
            <div
                #planedSlider
                class="  w-full h-[140px] justify-between mx-40 flex overflow-x-scroll scrollbar-hide"
            >
                <app-arc-percentage-chart
                    *ngFor="let slide of planedSlides"
                    appOnscrollAnimated
                    [clesses]="['animate-flip-up', 'animate-once']"
                    class="w-[190px] h-[100px] mx-5"
                    [radius]="65"
                    [stroke]="15"
                    [color]="slide.color"
                    [label]="slide.title"
                    [percentage]="slide.percentage"
                ></app-arc-percentage-chart>
            </div>
            <!-- <img
                appOnscrollAnimated
                class="cursor-pointer"
                (click)="
                    planedSlider.scroll({
                        left: planedSlider.scrollLeft - 500,
                        behavior: 'smooth'
                    })
                "
                src="./assets/images/Group 208.svg"
            /> -->
        </div>
    </section>
    <section class="py-5 px-2" id="reports">
        <app-page-title title="التقارير الدورية" class="my-2 mx-10"></app-page-title>
        <div class="flex mt-5">
            <img
                appOnscrollAnimated
                class="cursor-pointer"
                (click)="
                    reportsSlider.scrollTo({
                        left: 100,
                        behavior: 'smooth'
                    })
                "
                src="./assets/images/Group 210.svg"
            />
            <div
                #reportsSlider
                class="mx-2 flex w-full justify-center overflow-x-scroll scrollbar-hide"
            >
                <div
                    *ngFor="let slide of reportedSlides"
                    appOnscrollAnimated
                    [clesses]="[
                        'animate-jump-in',
                        'animate-once',
                        ' animate-ease-in-out'
                    ]"
                    class="border-gray-300 text-nowrap border-[1px] mx-3 text-center rounded-3xl py-3 px-14"
                >
                    <h3
                        style="font-family: Almarai; font-weight: 400"
                        class="text-black text-xs"
                    >
                        {{ slide.title }}
                    </h3>

                    <button
                        class="btn-tw w-[154px] justify-center gap-3 px-10 flex mx-auto mt-3"
                    >
                        <span class="font-[Almarai] font-[400]">عرض</span>
                        <img
                            src="./assets/images/download-interface-icon-svgrepo-com 1.svg"
                        />
                    </button>
                </div>
            </div>
            <img
                appOnscrollAnimated
                class="cursor-pointer"
                (click)="
                    reportsSlider.scroll({
                        left: planedSlider.scrollLeft - 500,
                        behavior: 'smooth'
                    })
                "
                src="./assets/images/Group 208.svg"
            />
        </div>
    </section>
    <section class="flex justify-center py-10 px-28 mt-20" id="sec">
        <div
            class="flex flex-col justify-start text-start items-start w-full my-auto"
        >
            <app-page-title title="نبذة عن المشروع"></app-page-title>

            <p style="font-family: Almarai !important" class="mt-2 text-md  max-w-[580px]">
                اطـلـقـت امــانــة مـنـطقـة الــمدينـة الـمنورة مـشـروع تـصـحيح
                و تحديث كافة الـمـخـططات التفصيلية و التنظيمية للمدينه
                الــمــنورة و الــضــواحـي الــتــابـعـة لـهـا باسـتـخدام
                المصورات الجوية و اعـمـال الـمـســح الـمـيــدانـي ضــمــن
                مـــبــادرة حــصــر الاراضي و الوحدات العــقارية في منطقة
                المدينة المنورة و اللتي تهدف الي التسريع مـن اعـمـال الـسـجـل
                الـعــقــاري للمدينة المنورة
            </p>
            <button
                class="btn-tw w-[154px] justify-center gap-3 px-10 flex mt-3"
            >
                <span class="font-[Almarai] font-[400]">اقرأ أكثر </span>
                <img src="./assets/images/Icon.png" />
            </button>
        </div>
            <img
                 class="w-[905px] h-[707.3px] animate-duration-[800ms] animate-delay-[600ms]  object-cover object-right"
                src="./assets/images/bb81e710591370e17bb471d5200b55ff.jfif"
            />
           
    </section>
</main>
